import { render, staticRenderFns } from "./realEstateFeature.vue?vue&type=template&id=6bb389d6&scoped=true&"
import script from "./realEstateFeature.vue?vue&type=script&lang=js&"
export * from "./realEstateFeature.vue?vue&type=script&lang=js&"
import style0 from "./realEstateFeature.vue?vue&type=style&index=0&id=6bb389d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb389d6",
  null
  
)

export default component.exports